import React, {useContext, useRef, useState, useEffect} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import Flag from 'react-world-flags'
import LoaderComp from 'components/base-components/loader'
import BaseButton from "components/base-components/base-button";
import Grow from "@material-ui/core/Grow";
import {Fade, Slide } from "@material-ui/core";
import {BreakPointContext} from 'contexts/breaking-point';
import countriesData from 'assets/data/country-data.json'
import { CountryContext } from '../../contexts/country-context';
import { BASE_URL } from '../../env'

const DisplayList = ({title, countryList, phoneCode, getSelectedCountry, selected, isSearching}) => {
    const selectCountry = (country) => {
        getSelectedCountry(country)
    }

    return (
        <>
            {!isSearching && (<p>
                {title}
            </p>)}

            <ul >
                {countryList.map( (country, i) => (
                        <li key={i}
                            className={selected === country.code ? "is-active" : ""}
                            onClick={() => { selectCountry (country) } }
                        >
                            <div>
                                <Flag code={country.code}  />
                                <span className={"country-name"} dangerouslySetInnerHTML={{__html: country.name}} />
                                { phoneCode && <span>(+{country.callingCode})</span> }
                            </div>

                            <span className={"fonticons-check"}></span>
                        </li>
                    )
                )}
            </ul>
        </>
    )
}

DisplayList.propTypes = {
    title: PropTypes.string,
    countryList: PropTypes.array,
    phoneCode: PropTypes.bool,
    selected: PropTypes.string,
    getSelectedCountry: PropTypes.func,
    isSearching: PropTypes.bool,
}

const CountrySelector = ({ selected, phoneCode, close, getCountry, title, exclude }) => {
    const lang = localStorage.getItem('language')
    const countryValue = useContext(CountryContext)
    const popular = ["BE", "FR", "LU"]
    const listWrapper = useRef()
    const value = useContext(BreakPointContext)
    // const [countriesFULL] = useState(countryValue.fullCountryList.slice(1))

    useEffect(() => {
        if (window.PageBus) {
                 window.PageBus.publish("analyticsServices", {pageID: "onboarding",
                stepSeq: "1",
                stepName: "personal info: country code search",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             }
            );
        }

        const countryService = `${BASE_URL}/onboarding-entrepreneur-front/v1/countries/`
        const dfltCountry = "BE"

        async function fetchCountry() {
        const res = await (await fetch(`${countryService}${lang}`)).json()
        const reRes = res.map(ctr => ({
            name: ctr.title,
            callingCode: ctr.phoneCode,
            code: ctr.iso2,
            isDefault: ctr.isDefault,
            priority: ctr.priority,
            translation: {
                de: ctr.title,
                fr: ctr.title,
                nl: ctr.title
            }
        }))
        const ordinaryList = reRes.filter(ctr => (ctr.priority === 0 && ctr.code !== "" && ctr.callingCode !== "" ))
        const popularList = reRes.filter(ctr => (ctr.priority !== 0 && ctr.priority < 9))
        setCountriesFULL(reRes.filter(ctr => (ctr.priority === 0)))

        setPopularCOuntries(exclude ? popularList.filter(ct => {
            return exclude && exclude.every(ex => ct.code !== ex ) 
        }) : popularList)
            
        setCountries(  exclude ? 
            ordinaryList.filter(ct => {
            return exclude && exclude.every(ex => ct.code !== ex )
            }) : ordinaryList)

        }
        fetchCountry()
    }, [])
    
    const [countriesFULL, setCountriesFULL] = useState([])
    const [countries, setCountries] = useState([])
    const [popularCountries, setPopularCOuntries] = useState([])
    const [selectedCountry, setSelectedCountry] = useState(selected)
    const [isSearching, setIsSearching] = useState(false)
    const [isScrolling, setIsScrolling] = useState(false)
    const [searchResult, setSearchResult] = useState([])
    const [show, setShow] = useState(true)

    const className = isSearching || isScrolling ? "is-searching country-selector" : "country-selector"

    const getSelectedCountry = (country) => {
        setSelectedCountry(country.code)
        getCountry(country) // send country to parent
        setShow(false)
        _close()
    }

    const _close = () => {
        setTimeout(function(){
            close()
        }, 200)
    }

    const searchCountry = (e) => {
        const value = e.target.value
        if(value !== '' && value !== ' ') {
            setIsSearching(true)
            const resultArray = countries.filter( country => {
                return country?.name?.toLowerCase().includes(value?.toLowerCase())
            })

            const valueRegex = new RegExp(value, 'gi')
            setSearchResult(resultArray.map(country => {
                return {
                    ...country,
                    name : country.name.replace(valueRegex, '<b>' + value + '</b>')
                }
            }))
        } else {
            setSearchResult([])
            setIsSearching(false)
        }
    }

    const handleOnScroll = () => {
        const scrollTop = listWrapper.current.getBoundingClientRect().top
        const top = 250
        setIsScrolling(scrollTop < top)
    }
    
    return (
        <>
            {!value.isMobile &&
                <Grow in={show} timeout={{ enter: 500, exit: 300}}>
                    <div className={className}>
                        <div className={className + '__header'}>
                            <BaseButton
                                className={"close-icon"}
                                icon={"cross"}
                                light
                                action={_close}
                            />
                        <div className={className + "__header__title"}>
                            {t("personal_infos.country_dropdown.title")}
                            {/* {title} */}
                        </div>
                        </div>

                        <div className={className + '__search'}>
                            <input type="text" onChange={searchCountry} placeholder={t("personal_infos.country_dropdown.title")} autoComplete="off" autoFocus/>
                            <div className={"search-icon fonticons-search"}></div>
                        </div>

                        <div className={className + '__list'} {...(!value.isMobile ? {onScroll: handleOnScroll} : '' )} >
                        <div className={"list-wrapper"} ref={listWrapper}>
                            
                                {/* {(!popularCountries.length > 0 || !countries.length > 0) && <LoaderComp />} */}
                                {( !countries.length > 0) && <LoaderComp />}

                                {isSearching &&
                                <DisplayList
                                    countryList={searchResult}
                                    phoneCode={phoneCode}
                                    selected={selectedCountry}
                                    getSelectedCountry={getSelectedCountry}
                                    isSearching={isSearching}
                                />}

                                {!isSearching && popularCountries.length > 0 &&
                                <DisplayList
                                    countryList={popularCountries}
                                    phoneCode={phoneCode}
                                    selected={selectedCountry}
                                    title={t("personal_infos.country_dropdown.popular")}
                                    getSelectedCountry={getSelectedCountry}
                                />}

                                {!isSearching && countries.length > 0 &&
                                <DisplayList
                                    countryList={countries}
                                    phoneCode={phoneCode}
                                    selected={selectedCountry}
                                    title={t("personal_infos.country_dropdown.alphabetic_order")}
                                    getSelectedCountry={getSelectedCountry}
                                /> }
                            </div>

                        </div>
                    </div>
                </Grow>
            }

            {value.isMobile &&
                <Slide direction="up" in={show} mountOnEnter unmountOnExit>
                <div className={className}>

                    <div className={className + '__header'}>
                        <BaseButton
                            className={"close-icon"}
                            icon={"cross"}
                            light
                            action={_close}
                        />
                        <div className={className + "__header__title"}> {title}  </div>
                    </div>

                    <div className={className + '__search'}>
                        <input type="text" onChange={searchCountry} placeholder={"Chercher"} autoComplete="off"/>
                        <div className={"search-icon fonticons-search"}></div>
                    </div>

                    <div className={className + '__list'} {...(!value.isMobile ? {onScroll: handleOnScroll} : '' )} >
                        <div className={"list-wrapper"} ref={listWrapper}>
                            {(!popularCountries.length > 0 || !countries.length > 0) && <LoaderComp />}

                            {isSearching &&
                            <DisplayList
                                countryList={searchResult}
                                phoneCode={phoneCode}
                                selected={selectedCountry}
                                getSelectedCountry={getSelectedCountry}
                                isSearching={isSearching}
                            />}

                            {!isSearching && popularCountries.length > 0 &&
                            <DisplayList
                                countryList={popularCountries}
                                phoneCode={phoneCode}
                                selected={selectedCountry}
                                title={"Plus populaire"}
                                getSelectedCountry={getSelectedCountry}
                            />}

                            {!isSearching && countries.length > 0 &&
                            <DisplayList
                                countryList={countries}
                                phoneCode={phoneCode}
                                selected={selectedCountry}
                                title={"Alphabetiquement"}
                                getSelectedCountry={getSelectedCountry}
                            /> }
                        </div>

                    </div>
                </div>
            </Slide>
            }


            <Fade in={show} timeout={{ enter: 300, exit: 500}} >
                <div className="dialog-box__backdrop"></div>
            </Fade>

        </>
    )
}

CountrySelector.propTypes = {
    name: PropTypes.string,
    phoneCode: PropTypes.bool,
    selected: PropTypes.string,
    close: PropTypes.func,
    getCountry: PropTypes.func,
    title: PropTypes.string,
}

CountrySelector.defaultProps = {
    name: "CountrySelector",
    phoneCode: false,
    selected: "BE"

}


export default CountrySelector